module.exports = __webpack_public_path__ + "static/media/chaima.cebaf4c1.jpg";